angular.module('MyHippoProducer.Controllers').directive('optionalLiabilitySection', function () {
    return {
        restrict: 'E',
        scope: {},
        templateUrl: 'pages/policy-details/sections/optional-liability/optional-liability.html',
    };
});
